// styles
import './styles/graphic.scss';

// Format number with K abbreviation
const formatK = (value, decimals = 0) => {
  if (value < 1000) return `${Math.round(value)}`;
  const k = value / 1000;
  return decimals > 0 ? `${k.toFixed(decimals)}K` : `${Math.round(k)}K`;
};

export default function (props, container, isMobile) {
  const {
    color,
    labelColor,
    data,
    fmtYearAbbrev,
    fmtYearFull,
    fmtMonth,
    fmtMonthYear,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
  } = props;

  const xTicks = isMobile ? 5 : 10;
  const yTicks = 4; // Fixed tick count for ~10K intervals

  const xGrid = xAxis(x)
    .ticks(xTicks)
    .tickFormat(d => (isMobile
      ? `\u2019${fmtYearAbbrev(d)}`
      : fmtYearFull(d)));

  // legend
  // container.insert('ul', ':first-child')
  //   .attr('class', 'key')
  //   .selectAll('li')
  //   .data(data)
  //   .enter()
  //   .append('li')
  //   .attr('class', 'key-item')
  //   .html(d => `<span class='key-block' style='background-color:${color(d.id)};'></span> ${d.id.toUpperCase()}`);

  // svg

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  // x axis
  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xGrid);

 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y).ticks(yTicks));

  // Format y-axis labels with K abbreviation
  yGrid.selectAll('text')
    .text(d => formatK(d));

  yGrid.selectAll('line').attr('x2', width);

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'line');

  lines.append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));

  // labels
  const label = lines.append('g')
    .attr('class', 'data-label');

  const textEl = label.append('text')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 5;
      const y0 = y(d0.value) - 5;
      return `translate(${[x0, y0]})`;
    });

  textEl.append('tspan')
    .attr('x', 0)
    .attr('dy', 0)
    .attr('fill', d => labelColor(d.id))
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      return isMobile
        ? formatK(d0.value, 1)
        : `${d.id.toUpperCase()}: ${formatK(d0.value, 1)}`;
    });

  const lastDate = data[0].values[data[0].values.length - 1].date;
  const topY = Math.min(...data.map(d => y(d.values[d.values.length - 1].value)));

  g.append('text')
    .attr('class', 'last-date-label')
    .attr('transform', `translate(${[x(lastDate) + 5, topY - 18]})`)
    .text(fmtMonthYear(lastDate));
}
